import Text from '../Base/Text/Text';
import styles from './PatientItem.module.scss';

export default function PatientItem(props) {
	const { user, onClick } = props;

	const handleClick = () => {
		onClick?.({
			id: user.id,
			label: user.profile.fullName,
		});
	};

	return (
		<div
			className='autocomplete-custom-patient-search no-border'
			onClick={handleClick}>
			<div className='autocomplete-custom-patient-search__content'>
				<div className='autocomplete-custom-patient-search__content__title'>
					<Text tx={user.profile.fullName} />
				</div>
				<div className='autocomplete-custom-patient-search__content__subtitle'>
					r.č.: {user.profile.birthNumber} -{' '}
					<Text tx={user.profile.age + ' let'} inline />,
					{user.profile.address.fullAddress}
				</div>
				<div className='autocomplete-custom-patient-search__content__subtitle'>
					{user.doctors}
				</div>
			</div>
		</div>
	);
}

PatientItem.propTypes = {};
